module.exports = __webpack_public_path__ + "media/images/tile-icon-2dcafc55905daa99cf80bfb2fe0d73a4.svg";